import React from 'react';
import { css } from '@emotion/react';

import { Link, useParams } from 'react-router-dom';
import { useQuery } from 'urql';
import { RequestForm } from './forms/RequestForm';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { routes } from 'routes';

import { QUERY_BOOKER_REQUEST } from 'queries/queries-booker';
import { theme } from 'styles/theme';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { CopyToClipboard } from './components/CopyToClipboard';
import { LinkExternal } from 'components/LinkExternal';

export const ScreenEditRequest = () => {
	const { id } = useParams();
	const url = id;

	const [request, _executeRequest] = useQuery({
		query: QUERY_BOOKER_REQUEST,
		variables: { url: url },
	});

	const { data, fetching } = request;

	const requestURL = process.env.BASE_URL + 'booking/' + url + '/';

	// TODO vyfiltrovat data do formulare

	return (
		<div>
			<Header>
				<Heading
					left={
						<div>
							{/* <div>
								<Link to={routes.booker.request}>{'<-'} Zpět</Link>
							</div> */}
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
									// margin-top: 16px;

									display: flex;
									align-items: center;
									gap: 12px;
								`}
							>
								<Link
									to={routes.booker.request}
									css={css`
										color: ${theme.color.text[300]};

										&:hover {
											text-decoration: none;
										}
									`}
								>
									Poptávky
								</Link>
								<span
									css={css`
										color: ${theme.color.text[300]};
									`}
								>
									-&gt;
								</span>
								{url}
							</h1>
						</div>
					}
				></Heading>
			</Header>
			<div
				css={css`
					display: flex;
					padding: 32px;
					width: 640px;
					flex-direction: column;
				`}
			>
				<div
					css={css`
						display: flex;
						align-items: center;
						justify-content: space-between;
						border: 1px solid ${theme.color.primary['400']};
						background: #fafaff;
						border-radius: 12px;
						padding: 12px 20px;
						margin-bottom: 20px;
					`}
				>
					<div>
						<div
							css={css`
								font-weight: 600;
							`}
						>
							Odkaz na poptávku
						</div>
						<div
							css={css`
								font-size: 13px;
							`}
						>
							<LinkExternal href={requestURL}>{requestURL}</LinkExternal>
						</div>
					</div>
					<div>
						<CopyToClipboard small value={requestURL}>
							Zkopírovat
						</CopyToClipboard>
					</div>
				</div>

				{fetching && <SpinnerBlock />}
				{!fetching && <RequestForm defaultValues={data?.request} id={data?.request?.id} />}
			</div>
		</div>
	);
};
